import ContractItemExchangeCurrency from './contract-item-exchange-currency.entity';

export default class ContractItemExchange {
  convertFrom: ContractItemExchangeCurrency;

  convertTo: ContractItemExchangeCurrency;

  constructor(obj: any) {
    this.convertFrom = ContractItemExchangeCurrency.of(obj.convertFrom);
    this.convertTo = ContractItemExchangeCurrency.of(obj.convertTo);
  }

  public static of(obj: any): ContractItemExchange {
    return new ContractItemExchange(obj || {});
  }

  public static ofList(obj: any[]): ContractItemExchange[] {
    return obj.map(this.of);
  }
}
